module.exports = __webpack_public_path__ + "img/sep-2.0852a37c.jpg";